import { ValidationResult, ValidationError, RequiredFieldCheck } from '@/views/helpers/validation-result';
import ValidationMessages from '@/views/helpers/validation-messages';

export default {
  validate (employmentRelationship) {
    let validationResult = new ValidationResult();

    validationResult.push(this.validateEmployeeNumber(employmentRelationship.employeeNumber));
    validationResult.push(this.validateUntilDate(employmentRelationship));
    validationResult.push(this.validateAbsenceOnFromDate(employmentRelationship.absenceOnFromDate));

    return validationResult;
  },

  requiredFields (employmentRelationship) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('employeeNumber', employmentRelationship.employeeNumber));
    validationResult.push(RequiredFieldCheck('fromDate', employmentRelationship.fromDate));
    validationResult.push(RequiredFieldCheck('absenceOnFromDate', employmentRelationship.absenceOnFromDate));

    return validationResult;
  },

  validateEmployeeNumber (employeeNumber) {
    if (employeeNumber != null && employeeNumber.length > 25) {
      return new ValidationError({
        message: ValidationMessages.EmploymentRelationship.EMPLOYEE_NUMBER_EXCEED_CHAR_LIMIT,
        attribute: 'employeeNumber'
      });
    }
  },

  validateUntilDate (employmentRelationship) {
    if (employmentRelationship.fromDate == null || employmentRelationship.untilDate == null) return;

    if (new Date(employmentRelationship.fromDate) > new Date(employmentRelationship.untilDate)) {
      return new ValidationError({
        message: ValidationMessages.EmploymentRelationship.FROM_DATE_GREATER_THAN_UNTIL_DATE,
        attribute: 'untilDate'
      });
    }
  },

  validateAbsenceOnFromDate (value) {
    if (value !== false) {
      return new ValidationError({
        message: ValidationMessages.EmploymentRelationship.CANNOT_BE_ABSENT_ON_FROM_DATE,
        attribute: 'absenceOnFromDate'
      });
    }
  }
};
